import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import '../styles/header.css';
import '../styles/index.css';

const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={handleLogoClick}>
          <img src="/images/brand/logo.png" alt="Logo" />
        </div>
        <nav className="desktop-nav">
          <NavLink to="/solutions">Solutions</NavLink>
          <NavLink to="/product">Products</NavLink>
          <NavLink to="/industries">Industries</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <NavLink to="/request-demo" className="nav-cta">Request a demo</NavLink>
        </nav>
        <MobileMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} handleLinkClick={handleLinkClick} />
      </div>
    </header>
  );
};

export default Header;
